import React, { Component } from "react";
// import { Cart } from './Cart'
import "./style.scss";
import { CustomerAppointment } from "./customerAppoitment";
// import { Treatment } from './treatments';
import Availability from "./Availability";
import { dateFormat } from "service/helperFunctions";
import { getCommonApi } from "redux/actions/common";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { NormalModal } from "component/common";
import closeIcon from "assets/images/close.png";
import { history } from "helpers";

let deviceWidth = window.innerWidth;

export class CreateAppointmentClass extends Component {
  state = {
    list: [],
    isOpenModal: false,
    PasteAppointmentId: "",
  };

  componentDidMount = () => {};

  render() {
    let { isOpenModal } = this.props;
    return (
      <>
        <NormalModal
          className="col-12 col-md-12 col-sm-12"
          style={{
            minWidth:
              deviceWidth < 768
                ? "95%"
                : deviceWidth >= 768 && deviceWidth <= 1200
                ? "95%"
                : "80%",
            minHeight: "90%",
          }}
          modal={isOpenModal}
          handleModal={this.props.handleCloseDialog}
        >
          <img
            onClick={this.props.handleCloseDialog}
            className="close"
            src={closeIcon}
            alt=""
          />
          <div className="row">
            <div className=" col-md-12 col-12 appointment-box appointment-col">
              <div className="appointment">
                <div className="appointment-holder">
                  <CustomerAppointment
                    handleCloseDialog={this.props.handleCloseDialog}
                    handleSaveorUpdate={this.props.handleSaveorUpdate}
                  />
                </div>
              </div>
            </div>
          </div>
        </NormalModal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  customerDetail: state.appointment.customerDetail,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
    },
    dispatch
  );
};

export const NewCreateAppointment = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateAppointmentClass);
